// Mock data for Ess Bee Heaters clone

export const heroSlides = [
  {
    id: 1,
    image: 'https://essbeeheaters.com/data1/images/bb1.jpg',
    alt: 'Heater Products Banner 1',
  },
  {
    id: 2,
    image: 'https://essbeeheaters.com/data1/images/bb2.jpg',
    alt: 'Heater Products Banner 2',
  },
  {
    id: 3,
    image: 'https://essbeeheaters.com/data1/images/bb3.jpg',
    alt: 'Heater Products Banner 3',
  },
];

export const products = [
  { slug: 'high-watt-density-cartridge-heater', name: 'HIGH WATT DENSITY CARTRIDGE HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029389Untitled-1.jpg' },
  { slug: 'hot-air-gun-heaters', name: 'HOT AIR GUN HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029591Untitled-1.jpg' },
  { slug: 'hot-air-gun-machines', name: 'HOT AIR GUN MACHINES', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029711Untitled-1.jpg' },
  { slug: 'knife-box-heaters', name: 'KNIFE BOX HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029811Untitled-1.jpg' },
  { slug: 'low-watt-density-cartridge-heaters', name: 'LOW WATT DENSITY CARTRIDGE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029961Untitled-1.jpg' },
  { slug: 'main-fold-heaters', name: 'MAIN FOLD HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721030027Untitled-1.jpg' },
  { slug: 'medium-wave-ir-heaters-quartz-silica-heaters', name: 'MEDIUM WAVE IR / QUARTZ SILICA HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721032709Untitled-1.jpg' },
  { slug: 'mica-band-heaters', name: 'MICA BAND HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721032779Untitled-1.jpg' },
  { slug: 'mini-space-heaters', name: 'MINI SPACE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721032851MINI%20SPACE%20HEATERS.jpg' },
  { slug: 'oil-immersion-heaters', name: 'OIL IMMERSION HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721033051Untitled-1.jpg' },
  { slug: 'quartz-box-heaters-silica-box-heaters', name: 'QUARTZ BOX / SILICA BOX HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721033151Untitled-1.jpg' },
  { slug: 'ring-type-heaters', name: 'RING TYPE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721033271Untitled-1.jpg' },
  { slug: 'round-plate-immersion-heaters', name: 'ROUND PLATE IMMERSION HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721033384Untitled-1.jpg' },
  { slug: 'sealed-nozzle-heater', name: 'SEALED NOZZLE HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721033626Untitled-1.jpg' },
  { slug: 'shortwave-ir-heater', name: 'SHORTWAVE IR HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721034372Untitled-1.jpg' },
  { slug: 'shortwave-ir-heaters-with-reflector-box', name: 'SHORTWAVE IR HEATERS WITH REFLECTOR BOX', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721034936Untitled-1.jpg' },
  { slug: 'sic-heating-elements', name: 'SIC HEATING ELEMENTS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721035097Untitled-1.jpg' },
  { slug: 'water-immersion-heaters', name: 'WATER IMMERSION HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593058Untitled-4.jpg' },
  { slug: 'tubler-heaters', name: 'TUBLER HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593229Untitled-4.jpg' },
  { slug: 'thread-buring-heaters', name: 'THREAD BURNING HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593411Untitled-4.jpg' },
  { slug: 'tape-heaters', name: 'TAPE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593552Untitled-4.jpg' },
  { slug: 'strip-heaters-strip-finned-heater', name: 'STRIP HEATERS / STRIP FINNED HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593669Untitled-4.jpg' },
  { slug: 'space-heaters', name: 'SPACE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1720593761Untitled-4.jpg' },
  { slug: 'air-finned-heaters', name: 'AIR FINNED HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721027701Untitled-1.jpg' },
  { slug: 'aluminum-casting-heaters', name: 'ALUMINUM CASTING HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028015Untitled-1.jpg' },
  { slug: 'bobbine-heaters', name: 'BOBBINE HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028189Untitled-1.jpg' },
  { slug: 'brass-casting-heaters', name: 'BRASS CASTING HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028322Untitled-1.jpg' },
  { slug: 'cast-iron-heaters', name: 'CAST IRON HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028488qz.jpg' },
  { slug: 'ceramic-band-heaters', name: 'CERAMIC BAND HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028756Untitled-1.jpg' },
  { slug: 'ceramic-ir-heaters', name: 'CERAMIC IR HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028842Untitled-1.jpg' },
  { slug: 'chemical-immersion-heaters', name: 'CHEMICAL IMMERSION HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028954Untitled-1.jpg' },
  { slug: 'coil-heaters', name: 'COIL HEATERS', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029103Untitled-1.jpg' },
  { slug: 'd-type-cartridge-heater', name: 'D TYPE CARTRIDGE HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721029186Untitled-1.jpg' },
  { slug: 'electric-nano-infraded-band-heater', name: 'ELECTRIC NANO INFRARED BAND HEATER', image: 'https://essbeeheaters.com/admin/uploads/product/cat_pd_image/1721028842Untitled-1.jpg' },
];

export const galleryImages = [
  'https://essbeeheaters.com/admin/uploads/gallery/1722083112main-fold-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083133medium-wave-ir-heaters-quartz-silica-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083148mica-band-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083168mini-space-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083193oil-immersion-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083212quartz-box-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083225ring-type-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083240round-plate-immersion-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083258sealed-nozzle-heater.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083277shortwave-ir-heater.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083291shortwave-ir-heater-with-box.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083304sic-heating-elements.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083319space-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083332strip-heaters-strip-finned-heater.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083349tape-heater-heat-treacer.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083364thread-burning-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1722083394tubler-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1720598264water-immersion-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035464air-finned-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035496aluminum-casting-heater.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035519brass-casting-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035546cast-iron-casting-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035563ceramic-band-heaters.jpg',
  'https://essbeeheaters.com/admin/uploads/gallery/1721035579ceramic-ir-heaters.jpg',
];

export const testimonials = [
  {
    id: 1,
    name: 'Mayank Khandelwal',
    role: 'Happy Customer',
    avatar: 'https://essbeeheaters.com/admin/uploads/testimonial/1720677190unnamed--1-.png',
    message: 'They have the best quality products at affordable prices. Also, loved the variety of heaters they offer.',
  },
  {
    id: 2,
    name: 'Deepak Shukla',
    role: 'Happy Customer',
    avatar: 'https://essbeeheaters.com/admin/uploads/testimonial/1720677006unnamed.png',
    message: 'Very cheap heaters are available here from shops. The quality is excellent and prices are very reasonable.',
  },
  {
    id: 3,
    name: 'Vivek Kumar',
    role: 'Happy Customer',
    avatar: 'https://essbeeheaters.com/admin/uploads/testimonial/1673858677unnamed--3-.png',
    message: 'Nice range of industrial heating elements with good quality available with them.',
  },
  {
    id: 4,
    name: 'Amar Kushwaha',
    role: 'Happy Customer',
    avatar: 'https://essbeeheaters.com/admin/uploads/testimonial/1720677305unnamed--2-.png',
    message: 'Quality products with reasonable prices and good human behavior with customers.',
  },
];

export const companyInfo = {
  name: 'Ess Bee Heaters Pvt. Ltd.',
  tagline: 'Heat Solution',
  established: 'An ISO 9001:2015 Certified Company',
  phone: ['+91-9911565091', '+91-9911565090'],
  contacts: [
    { name: 'Mr. Hrithik Bansal', phone: '+91-9911565091', role: 'Director' },
    { name: 'Mr. Sunil Bansal', phone: '+91-9911565090', role: 'Director' },
  ],
  email: ['ess_beeheat@yahoo.com', 'sunilbansal151@gmail.com'],
  address: 'KH. No. 22/6/01, Gali No. 9, Pipalwali gali, Samaypur Extn. Indl. Area., Delhi -110042',
  whatsapp: '919911565091',
  socials: {
    facebook: '#',
    linkedin: '#',
    youtube: 'https://www.youtube.com/watch?v=csjwGW3j2RU',
    instagram: '#',
  },
  youtubeId: 'csjwGW3j2RU',
};

export const industries = [
  'OEMs', 'Food Processing', 'Textiles', 'Plastic Industry', 'Rubber Industry',
  'Chemical & Pharmaceutical', 'Electroplating', 'Fertilizer Plants',
  'PET Industries', 'Foam Plant', 'Cooler Honey Pad', 'Packaging Industries',
];
